import { Component, OnInit, Input, OnChanges, SimpleChanges } from '@angular/core';
import { CommonModule } from '@angular/common';
import { NgxSkeletonLoaderModule } from 'ngx-skeleton-loader';

@Component({
  selector: 'app-skeleton',
  templateUrl: './skeleton.component.html',
  styleUrls: ['./skeleton.component.scss'],
  standalone: true,
  imports: [CommonModule]
})
export class SkeletonComponent implements OnInit, OnChanges {
  @Input() type: string;
  constructor() {}

  ngOnInit() {}
  ngOnChanges(changes: SimpleChanges) {
    // console.log('changes', changes);
    if (changes.type.currentValue) this.type = changes.type.currentValue;
  }
}
